<template>
  <div class="make-offers-page">
    <div class="basic-setup">
      <div class="make-offers-title">
        <div class="make-offers-num">
          <span>1</span>
        </div>
        <div class="make-offers-title-name">
          <span>基本信息设置</span>
          <span class="asterisk">*</span>
        </div>
      </div>
      <div class="basic-setup-content">
        <a-form :form="form"
                @submit="handleSubmit">
          <a-row class="a-row-input">
            <a-col class="a-col-input">
              <a-form-item label="往来单位">
                <a-input placeholder="请输入菜单路径"
                         v-decorator="['unit', {}]"
                         class="border-radius-input">
                  <a-tooltip slot="suffix"
                             title="更多">
                    <img src="@/assets/image/gengduo.png"
                         alt=""
                         style="width: 12px;">
                  </a-tooltip>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col class="a-col-input">
              <a-form-item label="发货仓库">
                <a-select labelInValue
                          style="width: 200px;"
                          placeholder="选择发货仓库"
                          @change="ChangeWarehouse">
                  <a-icon slot="suffixIcon"
                          type="caret-down"
                          style="color: #555555" />
                  <a-select-option value="jack"
                                   v-for="(item, index) in formInfo.warehouseList"
                                   :key="index"></a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="a-col-input">
              <a-form-item label="菜单名称">
                <a-input placeholder="请输入菜单名称"
                         class="border-radius-input"
                         v-decorator="['name', { rules: [{ required: true, message: '请输入菜单名称' }] }]"
                         style="width: 200px;" />
              </a-form-item>
            </a-col>
            <a-col class="a-col-input">
              <a-form-item label="单据日期">
                <a-date-picker v-decorator="['date',  { rules: [{ required: true, message: '请选择单据日期' }] }]" />
              </a-form-item>
            </a-col>
            <a-col class="a-col-input">
              <a-form-item label="经办人">
                <a-select labelInValue
                          style="width: 200px;"
                          placeholder="选择经办人"
                          @change="ChangeWarehouse">
                  <a-icon slot="suffixIcon"
                          type="caret-down"
                          style="color: #555555" />
                  <a-select-option value="jack"
                                   v-for="(item, index) in formInfo.warehouseList"
                                   :key="index"></a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="a-col-input">
              <a-form-item label="备注">
                <a-input placeholder="请输入备注"
                         class="border-radius-input"
                         v-decorator="['name', {}]"
                         style="width: 400px;" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="choose-products">
      <div class="make-offers-title">
        <div class="make-offers-num">
          <span>2</span>
        </div>
        <div class="make-offers-title-name">
          <span>选择商品</span>
          <span class="asterisk">*</span>
        </div>
      </div>
      <div class="choose-products-table">
        <a-table :columns="columns"
                 :dataSource="dataSource"
                 rowKey="id">
          <template slot="name"
                    slot-scope="text, record">
            <a-input placeholder="请输入备注"
                     style="width: 200px;" />
          </template>
          <!-- <template slot="operation"
                    slot-scope="text, record">
            <a class="table-redact"
               @click="btnEditMenu(record)">编辑</a>
            <a-popconfirm title="确定删除吗?"
                          @confirm="() => btnDeleteMenu(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </template> -->
        </a-table>
      </div>
    </div>
    <div class="amount-subtotal">
      <div class="make-offers-title">
        <div class="make-offers-num">
          <span>3</span>
        </div>
        <div class="make-offers-title-name">
          <span>金额小计</span>
        </div>
      </div>
      <div class="amount-subtotal-content">
        <span class="price-unit">¥</span>
        <span class="price-num">3500.00</span>
      </div>
    </div>
    <div class="accessory">
      <div class="make-offers-title">
        <div class="make-offers-num">
          <span>3</span>
        </div>
        <div class="make-offers-title-name">
          <span>附件文件</span>
        </div>
      </div>
      <div class="accessory-content">
        <div class="uploading-button">
          <a-button icon="upload"
                    class="upload-button">
            上传附件
          </a-button>
        </div>
        <div class="file-list-style">
          <div class="file-style">
            <div class="file-image">
              <img src="@/assets/image/word@2x.png"
                   alt=""
                   class="image">
            </div>
            <div class="file-name-size">
              <span class="name">销售文件.docx</span>
              <span class="size">200k</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pick from 'lodash.pick'
export default {
  name: 'makeOffers',
  data () {
    return {
      formInfo: {
        unit: '',           // 往来单位
        warehouseList: [],   // 仓库列表
        date: '',             // 单据日期
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          width: 232,
          scopedSlots: { customRender: 'name' }
        }, {
          title: '商品图片',
          dataIndex: 'commodity',
        }, {
          title: '规格',
          ellipsis: true,
          dataIndex: 'specification'
        }, {
          title: '型号',
          ellipsis: true,
          dataIndex: 'model'
        }, {
          title: '单位',
          ellipsis: true,
          dataIndex: 'unit'
        }, {
          title: '品牌',
          ellipsis: true,
          dataIndex: 'brand'
        }, {
          title: '产地',
          ellipsis: true,
          dataIndex: 'place'
        }, {
          title: '适配机型',
          ellipsis: true,
          dataIndex: 'adaptive'
        }, {
          title: '可售数量',
          ellipsis: true,
          dataIndex: 'sellingnum'
        }, {
          title: '售价',
          ellipsis: true,
          dataIndex: 'sellingprice'
        }, {
          title: '备注',
          ellipsis: true,
          dataIndex: 'remark'
        }, {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        }
      ],
      dataSource: [{}, {}, {}],
      form: this.$form.createForm(this)
    }
  },
  mounted () {

  },
  methods: {
    // 选择仓库
    ChangeWarehouse () {

    },
    // 赋值数据（方法描述）
    setInputData () {
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.menuData, 'url', 'component', 'name', 'icon'))
      })
    },
    // 提交
    handleSubmit (e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let formData = {}
          formData.title = values.title
        }
      })
    }
  }
}
</script>

<style lang="scss">
.make-offers-page {
  .make-offers-title {
    height: 36px;
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #ffffff;
    .make-offers-num {
      width: 36px;
      height: 36px;
      background: var(--bg);
      border-radius: 50%;
      line-height: 36px;
      text-align: center;
    }
    .make-offers-title-name {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      margin-left: 15px;
    }
  }

  .basic-setup {
    padding: 55px 30px;
    background-color: #ffffff;
    .basic-setup-content {
      padding: 30px 0 0 30px;
      .a-row-input {
        width: 100%;
        .a-col-input {
          display: inline-block;
          margin-right: 40px;
          .ant-form-item {
            display: flex;
            .ant-form-item-label {
              width: 100px;
              text-align: right;
              padding-right: 0 !important;
            }
            .ant-form-item-control-wrapper {
              width: 200px;
            }
          }
          .ant-calendar-picker-input {
            width: 200px;
            border-radius: 6px !important;
          }
        }
      }
    }
  }

  .choose-products {
    padding: 50px 30px;
    background-color: #ffffff;
    margin: 14px 0;
    .choose-products-table {
      .ant-table-thead {
        tr {
          th {
            height: 50px;
            padding: 0 16px !important;
          }
        }
      }
      .ant-table-tbody {
        tr {
          td {
            padding: 10px 16px !important;
          }
        }
      }
    }
  }

  .amount-subtotal {
    padding: 50px 30px;
    background-color: #ffffff;
    margin: 14px 0;
    .amount-subtotal-content {
      color: #f76f14;
      font-weight: bold;
      padding: 40px 0 0 52px;
      display: table-cell;
      vertical-align: bottom;
      .price-unit {
        display: inline-block;
        font-size: 18px;
      }
      .price-num {
        font-size: 50px;
      }
    }
  }

  .accessory {
    padding: 50px 30px;
    background-color: #ffffff;
    margin: 14px 0;
    .accessory-content {
      padding: 34px 0 0 52px;
      .file-list-style {
        margin-top: 25px;
        .file-style {
          width: 274px;
          height: 74px;
          display: flex;
          align-items: center;
          padding: 16px 26px;
          border: 1px dashed #dddddd;
          .file-image {
            .image {
              width: 34px;
              height: 39px;
            }
          }
          .file-name-size {
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 16px;
            .name {
              font-size: 16px;
              font-weight: bold;
            }
            .size {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
